import { ModalErrorState } from '@/models/modal.interface';
import { CrmDataProcessorClient, TableauDashboardAccess } from '@studyportals/crm-data-processor-interface';
import { LoadingState } from '@/models/loading.interface';
import { DashboardAccessItem, ActClientProductPayment } from '@/models/dashboard-data.interface';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import cookieHandler from '@/infrastructure/cookie-handler';
import store from '@/store';

class DashboardsPresenter {
	private client: CrmDataProcessorClient;
	private readonly tokenId: string;

	constructor() {
		this.tokenId = cookieHandler.retrieveTokenIdCookie();
		this.client = new CrmDataProcessorClient(
			webpackDefinitions.CRM_DATA_PROCESSOR_URL,
			async () => this.tokenId
		);
	}

	public async retrieveAvailableDashboards(): Promise<void> {
		try {
			const dashboards = await this.client.retrieveDashboardAccess();

			const dashboardsWithType: DashboardAccessItem[] = dashboards.map((dashboard: TableauDashboardAccess): DashboardAccessItem  => {
				// The Global Student Mobility dashboard is free and therefore always active.
				if (dashboard.id === 'ACT81') {
					return {
						...dashboard,
						active: true,
						type: ActClientProductPayment.FREE
					};
				}

				return {
					...dashboard,
					type: ActClientProductPayment.PAID
				};
			});

			store.mutations.setAvailableDashboards(dashboardsWithType);
			store.mutations.setLoadingStateDashboards(LoadingState.INACTIVE);
		} catch (e) {
			rollbarOperator.triggerError(e as Error);
			store.mutations.setModalErrorState(ModalErrorState.RETRIEVE_DASHBOARDS);
		}
	}
}

export default new DashboardsPresenter();
